export const DATA_BUILDER_ROW_LIMIT_FALLBACK_ERROR_MESSAGE =
  'Validation failed.';

export const extractDataBuilderRowLimitErrorMessage = (
  error: unknown
): string => {
  if (!(error instanceof Error) || error.message.length === 0) {
    return DATA_BUILDER_ROW_LIMIT_FALLBACK_ERROR_MESSAGE;
  }
  try {
    const parsed: unknown = JSON.parse(error.message);
    if (
      parsed !== null &&
      typeof parsed === 'object' &&
      'detail' in parsed &&
      typeof (parsed as { detail: unknown }).detail === 'string'
    ) {
      return (parsed as { detail: string }).detail;
    }
  } catch {
    // not JSON, fall through to raw message
  }
  return error.message;
};
